const MuiInputBase = {
  styleOverrides: {
    root: {
      marginBottom: 0,
    },
  },
};

export default MuiInputBase;
